import React, { useState } from 'react';
import ChatBubbleOutlineRoundedIcon from '@mui/icons-material/ChatBubbleOutlineRounded';
import CommonButton from '@src/new-components/Button';
import FeedbackDialog from '@src/containers/ProjectDetail/component/FeedbackDialog';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { COLOR } from '@src/styles/color';
import actions from '@src/redux/actions';

const PresentationFeedbackButton = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [openDialog, setOpenDialog] = useState(false);

  const handleOpenDialog = () => {
    dispatch(actions.layout.setIsPanelResizeDisabled(true));
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    dispatch(actions.layout.setIsPanelResizeDisabled(false));
    setOpenDialog(false);
  };

  return (
    <>
      <CommonButton
        variant="outlined"
        startIcon={
          <ChatBubbleOutlineRoundedIcon
            sx={{
              width: 24,
              height: 24,
              color: COLOR.indigo.default,
            }}
          />
        }
        customStyle={{
          height: 40,
          padding: '8px 16px',
          whiteSpace: 'nowrap',
          '& .MuiButton-startIcon': {
            marginLeft: 0,
          },
        }}
        onClick={handleOpenDialog}
        textProps={{
          variantText: 'body-14-semibold',
          color: COLOR.indigo.default,
        }}
      >
        {t('presentationProjectFeedback')}
      </CommonButton>
      <FeedbackDialog open={openDialog} onClose={handleCloseDialog} />
    </>
  );
};

export default PresentationFeedbackButton;
